require('./accessibility.js');
require('./cookies.js');
require('./navigation.js');
require('./forms.js');
require('./mini-cart.js');
require('./search-popout.js');
require('./modal.js');
require('./select2.js');
require('./footer.js');
require('./newsletter.js');
require('./subs-hero');